import { faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import theme from '../../theme/news12'
import getStoryHref from '../../utils/getStoryHref'
import { useEnvironmentContext } from '../EnvironmentProvider'

import moment from 'moment'
import 'moment-duration-format'

const playVideoButton = style => (
  <div className='play-video'>
    <img className='play-icon' src='/play-icon.svg' alt='' />
    <style jsx>{style}</style>
  </div>
)

const Card = ({ story, style }) => {
  const { canonicalUrlRedirects } = useEnvironmentContext()
  const DATE_FORMAT = 'MMM DD, YYYY, h:mma'
  const publicAt = story?.publishedAt ? moment(story?.publishedAt).format(DATE_FORMAT) : ''
  const href = getStoryHref(story, { canonicalUrlRedirects })

  return (
    <div className='card' data-testid='topStory-card'>
      <a className='card-content' href={href}>
        <div className='image-container'>
          <img className='image-hd' src={story?.thumbnail} alt='thumbnail image' />
        </div>
        <div className='top'>
          <div className='meatball-icon' style={{ display: 'none' }}>
            <FontAwesomeIcon icon={faEllipsisH} size={'sm'} color={theme.colors.mourineGray} />
          </div>
        </div>
        <p className='card-title'>{story?.title}</p>
        <div className='timestamp'>
          {publicAt} {story?.videoFile?.duration && playVideoButton(style)}
        </div>
      </a>
      <style jsx>{style}</style>
    </div>
  )
}

export default Card
